import { Facial } from 'utils/types/appTypes'
import { ServiceContent } from 'utils/types/maliblePageTypes'
import FacialCard from './facialCard'

type FacialServiceType = Facial & ServiceContent

interface FacialListProps {
  facials: FacialServiceType[]
  selectedFacial: string
  onSelectFacial: (facial: FacialServiceType) => void
}

export default function FacialList({
  facials,
  selectedFacial,
  onSelectFacial,
}: Readonly<FacialListProps>) {
  return (
    <>
      {facials?.map((facial) => {
        return (
          <FacialCard
            key={facial.id}
            selectedFacial={selectedFacial}
            facial={facial}
            onSelectFacial={onSelectFacial}
          />
        )
      })}
    </>
  )
}
